module.exports = __webpack_public_path__ + "img/como-funciona.55986c27.jpg";